import React from "react";
import styled, { keyframes } from "styled-components";
import car from "../media/police_car.svg";

const SceneWrapper = styled.div`
  width: 200px;
  height: 100px;
`;

const Driving = keyframes`
  0% {
    transform: translateY(0px) translateX(0px);
  }
  20% {
    transform: translateY(10px) translateX(-10px);
  }
  40% {
    transform: translateY(-5px) translateX(20px);
  }
  60% {
    transform: translateY(-20px) translateX(-10px);
  }
  80% {
    transform: translateY(10px) translateX(23px);
  }
  100% {
    transform: translateY(0px) translateX(0px);
  }
`;

const Car = styled.div`
  width: 200px;
  position: relative;
  animation: ${Driving} 5s ease-in-out infinite;
  img {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
  }
`;

const Pulse = keyframes`
  0% {
    transform: scale(0.3, 0.3);
    filter: blur(0px);
  }
  25% {
    transform: scale(2, 2);
    filter: blur(10px);
  }
  30% {
    transform: scale(0.3, 0.3);
    filter: blur(0px);
  }
  50% {
    transform: scale(4, 4);
    filter: blur(50px);
  }
  60% {
    transform: scale(0.3, 0.3);
    filter: blur(0px);
  }
  75% {
    transform: scale(2, 2);
    filter: blur(10px);
  }
  100% {
    transform: scale(0.3, 0.3);
    filter: blur(0px);
  }
`;

const Light = styled.div`
  width: 10px;
  height: 10px;
  display: block;
  border-radius: 50%;
  position: absolute;
  background: #0178ff;
  top: ${({ right }) => (right ? "16px" : "33px")};
  left: ${({ right }) => (right ? "100px" : "72px")};
  z-index: 4;
  animation: ${Pulse} 1s ease-in-out infinite;
  ${({ right }) => {
    if (right) {
      return `animation-duration: 1.2s`;
    }
    return ``;
  }};
  &::after {
    content: "";
    width: 5px;
    height: 5px;
    background: white;
    display: block;
    border-radius: 50%;
    position: absolute;
    left: 2px;
    top: 3px;
    opacity: 1;
  }
`;

const Shadow = styled.div`
  width: 191px;
  height: 67px;
  background: rgba(0, 0, 0, 0.4);
  filter: blur(10px);
  position: absolute;
  top: 0px;
  z-index: 1;
  transform: rotate(30deg) translateY(61px) translateX(21px) skew(-30deg);
`;

const Text = styled.h1`
  color: white;
  text-align: center;
  position: absolute;
  bottom: 80px;
  left: 0px;
  width: 100%;
  font-size: 20px;
`;

const Background = styled.div`
  width: 100vw;
  height: 100vh;
  background: ${({ theme }) =>
    `linear-gradient(hsla(221, 98%, 12%, 1), ${theme.colors.accent})`};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  @media screen and (min-width: 700px) {
    ${Text} {
      display: none;
    }
    width: 400px;
    height: 400px;
    border-radius: 50%;
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    top: 50%;
    transform: translateY(-50%);
    border: 10px white solid;
    box-shadow: 0px 11px 52px 0px rgb(1, 8, 41);
  }
`;

const LoaderWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100;
`;

const Scene = () =>
  <SceneWrapper>
    <Text>loading crime data</Text>
    <Car>
      <Light />
      <Light right />
      <img alt="car" src={car} />
      <Shadow />
    </Car>
  </SceneWrapper>;

const Loader = () =>
  <LoaderWrapper>
    <Background>
      <Scene />
    </Background>
  </LoaderWrapper>;

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader.js